import defaultPath from "../../../styles/svgs/default-icon.svg";

export const getSVGImagePath = async function (iconName) {
  if (!iconName) {
    return defaultPath;
  }

  try {
    const module = await import(`../../../styles/svgs/${iconName}.svg`);
    return module.default;
  } catch (e) {
    console.error(
      `SVGIconV2: getSVGImage: failed to load icon with the following name: ${iconName}, e:${e}`
    );
    return defaultPath;
  }
};
